













































































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import ValidatedPassword from '../NewWallet/ValidatedPassword.vue';
import { Action, State, Getter } from 'vuex-class';
import { LinkIdentity } from '~/mixins';
import TwoFactorAuthInputPrompt from '~/components/ModalPrompts/TwoFactorAuthInputPrompt.vue';
import { twoFaErrorCodes } from '~/utils/errorCodes';
import { TwoFaCheckpoint } from '~/types/two-fa-checkpoints';

@Component({
  components: {
    ValidatedPassword,
    TwoFactorAuthInputPrompt,
  },
})
export default class ResetAccountPassword extends Mixins(LinkIdentity) {
  @Prop(Function) readonly closeDialog!: Function;

  @State(profile => profile.user.email, { namespace: 'profile' })
  email!: string;

  @Getter('hasUsernamePasswordIdentity', { namespace: 'profile' })
  readonly hasUsernamePasswordIdentity!: boolean;

  @Action('updateUser', { namespace: 'profile' })
  private updateUser!: (args: any) => void;

  newPassword = '';
  passwordValid = false;
  confirmedNewPassword = '';
  currentPassword = '';
  showCurrentPass = false;
  showPass = false;
  inFlight = false;

  get passwordsMatch() {
    return this.confirmedNewPassword === this.newPassword;
  }

  get instructions() {
    return this.hasUsernamePasswordIdentity
      ? this.$t('components.settings.resetAccountPassword.fillOutFields')
      : this.$t('components.settings.resetAccountPassword.createPassword');
  }

  async created() {
    this.checkQueryParams();
  }

  confirmPassword(input: string) {
    const isValid = input === this.newPassword;
    if (isValid) {
      return true;
    }
    return this.$t(
      'components.settings.resetAccountPassword.passwordsNotMatch',
    );
  }

  handleCancel() {
    this.newPassword = '';
    this.confirmedNewPassword = '';
    this.passwordValid = false;
    this.closeDialog();
  }

  async mounted() {
    await this.$recaptcha.init();
  }

  async beforeDestroy() {
    await this.$recaptcha.destroy();
  }

  async handleReset() {
    if (!this.passwordValid || !this.passwordsMatch) return;
    this.inFlight = true;

    await this.doAuthQuery(async totpToken => {
      await this.updateUser({
        currentPassword: this.currentPassword,
        password: this.newPassword,
        totpToken,
        rethrowErrorCodes: twoFaErrorCodes,
      });

      this.newPassword = '';
      this.confirmedNewPassword = '';

      this.closeDialog();
    }, TwoFaCheckpoint.accountModifications);

    this.inFlight = false;
  }
}
